import { useEffect, useId, useRef, useState } from 'react';
import type { HistoryInvoice } from '../../../../historical-billing.ts';

/** An ordinary link popover: native Tab traversal, without ARIA menu key handling. */
export function InvoiceActions({invoice,month}:{invoice:HistoryInvoice;month:string}) {
  const [open,setOpen]=useState(false);
  const ref=useRef<HTMLDivElement>(null);
  const button=useRef<HTMLButtonElement>(null);
  const id=useId();
  useEffect(()=>{
    if (!open) return;
    const outside=(e:Event)=>{if(e.target instanceof Node && !ref.current?.contains(e.target))setOpen(false);};
    const escape=(e:KeyboardEvent)=>{if(e.key==='Escape'){setOpen(false);button.current?.focus();}};
    document.addEventListener('pointerdown',outside);document.addEventListener('focusin',outside);document.addEventListener('keydown',escape);
    return()=>{document.removeEventListener('pointerdown',outside);document.removeEventListener('focusin',outside);document.removeEventListener('keydown',escape);};
  },[open]);
  if(!invoice.hostedUrl && !invoice.pdfUrl)return null;
  return <div className="spend-invoice-menu" ref={ref}>
    <button className="btn btn-ghost" ref={button} aria-label={`Invoice actions for ${month}`} aria-expanded={open} aria-controls={open?id:undefined} onClick={()=>setOpen(v=>!v)}>
      Invoice <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>
    </button>
    {open && <div id={id} className="spend-invoice-popover" role="group" aria-label={`${month} invoice`}>
      {invoice.hostedUrl && <a href={invoice.hostedUrl} target="_blank" rel="noreferrer" onClick={()=>setOpen(false)}>View invoice</a>}
      {invoice.pdfUrl && <a href={invoice.pdfUrl} target="_blank" rel="noreferrer" onClick={()=>setOpen(false)}>Download PDF</a>}
    </div>}
  </div>;
}
